import { combineReducers } from "redux";
import accountsReducer from "./accounts";
import usersReducer from "./users";
import authenticationReducer from "./authentication";
import loaderReducer from "./loader";
import sessionReducer from "./session";
import notificationReducer from "./notification";
import { reducer as toastrReducer } from "react-redux-toastr";
import projectsReducer from "./projects";
import routerReducer from "./router";
import modalReducer from "./modal";
import blocksReducer from "./blocks";
import segmentsReducer from "./segments";
import promptsReducer from "./prompts";
import responsesReducer from "./responses";
import documentsReducer from "./documents";
import medicationsReducer from "./medications";
import plansReducer from "./plans";
import profilesReducer from "./profiles";
import adminReducer from "./admin";
import contactsReducer from "./contacts";
import transactionsReducer from "./transactions";
import partnersReducer from "./partners";
import messagesReducer from "./messages";
import navigationReducer from "./navigation";
import notesReducer from "./notes";
import noteTemplatesReducer from "./noteTemplates";
import coverageReducer from "./coverage";
import fastenReducer from "./fasten";
import oneTapReducer from "./oneTap";
import calendarReducer from "./calendar";
import smsGroupsReducer from "./smsGroups";
import accountAssistantReducer from "./account-assistant";
import projectCreationDraftReducer from "./projectCreationDraft";

const createRootReducer = (history) => combineReducers({
  router: routerReducer,
  session: sessionReducer,
  accounts: accountsReducer,
  users: usersReducer,
  contacts: contactsReducer,
  authentication: authenticationReducer,
  loader: loaderReducer,
  notification: notificationReducer,
  projects: projectsReducer,
  documents: documentsReducer,
  blocks: blocksReducer,
  segments: segmentsReducer,
  prompts: promptsReducer,
  responses: responsesReducer,
  toastr: toastrReducer,
  modal: modalReducer,
  medications: medicationsReducer,
  plans: plansReducer,
  profiles: profilesReducer,
  navigation: navigationReducer,
  admin: adminReducer,
  partners: partnersReducer,
  transactions: transactionsReducer,
  messages: messagesReducer,
  notes: notesReducer,
  noteTemplates: noteTemplatesReducer,
  coverage: coverageReducer,
  fasten: fastenReducer,
  oneTap: oneTapReducer,
  calendar: calendarReducer,
  smsGroups: smsGroupsReducer,
  accountAssistant: accountAssistantReducer,
  projectCreationDraft: projectCreationDraftReducer,
});
export default createRootReducer;